/* eslint-disable max-len */
import type { SvgProps } from '@main/core-ui/src/Icon/constants/enums';
import React from 'react';

export const StickersPaper: React.FC<SvgProps> = ({
  color,
  size,
  strokeWidth,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6673 12.8337H5.25065C4.94121 12.8337 4.64441 12.7109 4.4256 12.492C4.20679 12.2732 4.0839 11.9764 4.08398 11.667V5.83366C4.0839 5.52421 4.20679 5.22742 4.4256 5.00861C4.64441 4.7898 4.94121 4.66691 5.25065 4.66699H11.6673C11.9768 4.66691 12.2736 4.7898 12.4924 5.00861C12.7112 5.22742 12.8341 5.52421 12.834 5.83366V11.667C12.834 12.3113 12.3116 12.8336 11.6673 12.8337Z"
      stroke={color}
      strokeWidth={strokeWidth ?? '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.248 4.66683L9.80085 2.13112C9.74721 1.82637 9.57465 1.55542 9.32117 1.37793C9.0677 1.20044 8.75408 1.13095 8.44935 1.18477L2.13015 2.299C1.82539 2.35265 1.55445 2.5252 1.37695 2.77868C1.19946 3.03216 1.12998 3.34579 1.18379 3.65052L2.19672 9.39523C2.25037 9.7 2.42294 9.97096 2.67643 10.1484C2.92993 10.3259 3.24357 10.3954 3.54831 10.3416L4.08252 10.2474"
      stroke={color}
      strokeWidth={strokeWidth ?? '1.5'}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/* eslint-enable max-len */
